/* Performance Print Polo page (sections/sr-polo-pdp.liquid), LEP-1183.
   1. Fit table: draws the size chart from the size-recommender data (same numbers as the Size Guide popup), in/cm toggle.
   2. Second add to cart: it never adds to the cart itself. It picks the size in the MAIN buy box and presses the
      MAIN add-to-cart button, so the cart drawer, the bundle offer and every tracking pixel behave exactly as they
      do at the top of the page. The section tag renders once per page part, so this file guards against running twice. */
(function () {
  if (window.__srpPoloPdp) return;
  window.__srpPoloPdp = true;

  var FRACTIONS = { 0.25: '¼', 0.5: '½', 0.75: '¾' };

  function inches(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return value;
    var whole = Math.floor(n);
    var frac = Math.round((n - whole) * 4) / 4;
    if (frac === 1) { whole += 1; frac = 0; }
    return String(whole) + (FRACTIONS[frac] || '');
  }

  function centimetres(value) {
    var n = parseFloat(value);
    return isNaN(n) ? value : n.toFixed(1);
  }

  function initChart(section) {
    var dataEl = section.querySelector('[data-srp-chart]');
    var tableWrap = section.querySelector('[data-srp-chart-table]');
    if (!dataEl || !tableWrap) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var buttons = section.querySelectorAll('[data-srp-unit]');

    function draw(unit) {
      var fmt = unit === 'cm' ? centimetres : inches;
      var rows = [
        ['Width (' + unit + ')', unit === 'cm' ? data.wi_cm : data.wi_in],
        ['Length (' + unit + ')', unit === 'cm' ? data.le_cm : data.le_in]
      ];
      var html = '<table class="srp-table"><thead><tr><th>Size</th>';
      data.sizes.forEach(function (s) { html += '<th>' + s + '</th>'; });
      html += '</tr></thead><tbody>';
      rows.forEach(function (row) {
        if (!row[1] || !row[1].length || row[1][0] === '') return;
        html += '<tr><td>' + row[0] + '</td>';
        row[1].forEach(function (v) { html += '<td>' + fmt(v) + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table>';
      tableWrap.innerHTML = html;
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.srpUnit === unit ? 'true' : 'false'); });
    }

    buttons.forEach(function (b) { b.addEventListener('click', function () { draw(b.dataset.srpUnit); }); });
    draw('in');
  }

  function mainForm() {
    return document.querySelector('product-form-component form[action*="/cart/add"]');
  }

  function initAgain(section) {
    var sizeButtons = section.querySelectorAll('[data-srp-size]');
    var atc = section.querySelector('[data-srp-atc]');
    var flash = section.querySelector('[data-srp-flash]');
    var chosen = null;

    sizeButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        chosen = { size: b.dataset.srpSize, variant: b.dataset.srpVariant };
        sizeButtons.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (flash) flash.hidden = true;
      });
    });

    if (!atc) return;
    atc.addEventListener('click', function () {
      if (!chosen) {
        if (flash) flash.hidden = false;
        return;
      }
      var form = mainForm();
      var radio = document.querySelector('variant-picker input[type="radio"][data-variant-id="' + chosen.variant + '"]');
      if (!form || !radio) {
        // Buy box not found: fall back to the top of the page rather than guess.
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if (!radio.checked) radio.click();

      var started = Date.now();
      (function waitThenAdd() {
        var idInput = form.querySelector('input[name="id"]');
        var ready = idInput && idInput.value === chosen.variant;
        if (ready || Date.now() - started > 4000) {
          var addButton = document.querySelector('product-form-component button[name="add"]');
          if (addButton && ready) {
            addButton.click();
          } else {
            radio.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }
        setTimeout(waitThenAdd, 60);
      })();
    });
  }

  function init() {
    document.querySelectorAll('#srp-fit').forEach(initChart);
    document.querySelectorAll('[data-srp-again]').forEach(initAgain);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
